import { lazy, Suspense } from "react";
import MobileHeroBanner from "../HeroBanners/FlatHeroBanner";
import WorkspaceOptions from "./WorkspaceOptions";
import { LazyLoader } from "~/lib/utils/LazyLoader";
import OfficeSearchAndPartnerSectionMobile from "../common/OfficeSearchAndPartnerSectionMobile";
import { getFormattedCountryName } from "~/lib/helpers/constants";
import { Await } from "@remix-run/react";
import WhyOfficeHub from "../Home_Page/WhyOfficeHub";

// Lazy-loaded components
const OfficeSearchBanner = lazy(() => import("../common/OfficeBanner"));
const FAQs = lazy(() => import("../FAQs/FAQs"));
const BlogsSection = lazy(() => import("../Sections/BlogsSection"));

const MobileLayout = ({ country, blogs, faqs, countryName, searchUrl }) => {
  return (
    <div>
      <MobileHeroBanner
        title={`Office Space In ${getFormattedCountryName(country)} `}
        image={`${process.env.PUBLIC_REMIX_APP_ASSESTS_IMAGES}/assets/space-type-page/mobile-hero-banner.avif`}
      />

      <div className="px-4 md:px-10">
        <WorkspaceOptions isMobile={true} countryName={countryName} region={country} searchUrl={`${searchUrl}`} />
      </div>

      <OfficeSearchAndPartnerSectionMobile countryName={countryName} region={country} searchUrl={`${searchUrl}`} />
      <WhyOfficeHub region={country} searchUrl={`${searchUrl}`} isMobile={true} className="my-4" />

      {/* Blogs Section */}
      <Suspense fallback={null}>
        <Await resolve={blogs}>
          {(blogs) => {
            return (
              <div className='px-5'>
                <BlogsSection areaBlogs={blogs.blogs} description={`Explore trends, data, and tips shaping ${getFormattedCountryName(country)}’s dynamic office market`} />
              </div>
            )
          }}
        </Await>
      </Suspense>


      {/* <LazyLoader>
        <GoogleReviews country={getCountryName(country)} isMobile={false} />
      </LazyLoader> */}

      {/* FAQs */}
      <Suspense fallback={null}>
        <Await resolve={faqs}>
          {(faqs) => {
            return (
              <div className='md:px-10'>
                <FAQs title={`Answers to Common Workspace Queries in Australia`} faqs={faqs} />
              </div>
            )
          }}
        </Await>
      </Suspense>

      {/* Search Banner */}
      <LazyLoader>
        <OfficeSearchBanner country={country} />
      </LazyLoader>
    </div>
  );
};

export default MobileLayout;
